var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.683 22.25C9.16904 22.25 4.68304 17.764 4.68304 12.25C4.68304 6.736 9.16904 2.25 14.683 2.25C20.197 2.25 24.683 6.736 24.683 12.25C24.683 17.764 20.197 22.25 14.683 22.25ZM14.683 3.25C9.72042 3.25 5.68304 7.28737 5.68304 12.25C5.68304 17.2126 9.72042 21.25 14.683 21.25C19.6457 21.25 23.683 17.2126 23.683 12.25C23.683 7.28737 19.6457 3.25 14.683 3.25ZM18.8294 8.89637L13.183 14.5429L10.5367 11.8964L9.82929 12.6038L13.183 15.9571L19.5367 9.60363L18.8294 8.89637Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_851_264)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.683,
    y: 0.25,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#00884A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_851_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(18.683 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.1320bd7809121a977371cc47e0b2b314.svg";
export { ForwardRef as ReactComponent };